// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as NewOrderActions } from '../duck';
import { actions as AuthActions } from '../../auth/duck';
import { actions as AlertActions } from '../../alert/duck';
import { push } from 'react-router-redux';
import NewOrder from '../components/NewOrder';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    locale: state.locale,
    localValues: state.localValues,
    shoppingCart: state.shoppingCart.shoppingCart,
    bag: state.bag.bag,
    isBagLoading: state.bag.isPostingBag,
    isFetchingCart: state.shoppingCart.isFetchingCart,
    isFetchingBag: state.bag.isFetchingBag,
    isEditingShoppingCartItem: state.shoppingCart.isEditingItem,
    chosenVariants: state.abTest.chosenVariants,
    virtualShoppingCart: state.shoppingCart.virtualShoppingCart,
    virtualBag: state.bag.virtualBag,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...NewOrderActions,
    ...AuthActions,
    ...AlertActions,
    goToRedirect: (route: string) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NewOrder);



// WEBPACK FOOTER //
// ./src/modules/new-order/containers/NewOrderContainer.js